// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BreadcrumbsPresentationProps } from "@eisinc/MobiusOverrides/Breadcrumbs";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color } from "@eisinc/XDL/Utilities";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            ...fontConfig.singleLinexSmall,
            weight: "normal",
            ellipsis: true,
            css: css`
                letter-spacing: 0;
                max-width: 100%;
                word-wrap: break-word;
            `,
        },
        css: css`
            flex-wrap: wrap;
            gap: 12px 8px;
        `,
        tooltip: {
            cssOverrides: {
                tooltipBody: css`
                    &&& ${StyledButton} {
                        ${TypographyStyle} {
                            color: ${color("text")};
                        }
                        &:hover ${TypographyStyle} {
                            color: ${color("common.ui8")};
                        }
                        &:focus ${TypographyStyle} {
                            color: ${color("common.ui9")};
                        }
                    }
                    ${IconWrapper} {
                        display: none;
                    }
                `,
            },
        },
    } as BreadcrumbsPresentationProps,
} as xBaseTheme["breadcrumbs"];
